import { AccountDto } from "@bridge/server/src/api/accounts/dto/account.dto";

export const sendExit = () => {
  window.parent?.postMessage({ source: "bridge-connect", type: "exit" }, "*");
};

export const sendReconnectSuccess = (
  connectionId: string,
  institution: { id: string; name: string },
) => {
  window.parent?.postMessage(
    {
      source: "bridge-connect",
      type: "success",
      payload: {
        connectionId,
        institution: {
          id: institution.id,
          name: institution.name,
        },
      },
    },
    "*",
  );
};

export const sendSuccess = (
  connectionId: string,
  accounts: AccountDto[],
  institution: { id: string; name: string },
  user?: { id: string; externalUserId: string },
  scopedToken?: string,
) => {
  window.parent?.postMessage(
    {
      source: "bridge-connect",
      type: "success",
      payload: {
        connectionId,
        accounts,
        institution: {
          id: institution.id,
          name: institution.name,
        },
        user,
        scopedToken,
      },
    },
    "*",
  );
};
